module.exports = __webpack_public_path__ + "static/img/7.f9d8dfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/7.png
// module id = Fwcc
// module chunks = 0